<template>
    <div v-if="data" class="latest-news-id">
        <mobile v-show="'mobile' === deviceStore.type" :showBreadcrumb="false">
            <mobile-detail :data></mobile-detail>
        </mobile>
        <desktop v-show="'desktop' === deviceStore.type" :showBreadcrumb="false">
            <desktop-detail :data></desktop-detail>
        </desktop>
    </div>
</template>

<script setup>
import desktop from '../desktop/index.vue';
import mobile from '../mobile/index.vue';
import mobileDetail from './mobile/detail';
import desktopDetail from './desktop/detail';
import { useDeviceStore } from '~/store/device';
import { useNewsStore } from '~/store/news';
import { useMenusStore } from '~/store/menus';
import { useI18n } from 'vue-i18n';
import { get } from '~/http';

const deviceStore = useDeviceStore();
const newsStore = useNewsStore();
const menusStore = useMenusStore();
const { locale } = useI18n();
const route = useRoute();
const reqURL = useRequestURL();
const id = route.params.id;

const { data } = await get('/app/article/info', { id });

if (!data) {
    const fullPath = menusStore.getPathnameFull('latest-news') || menusStore.getPathnameFull('news') || '';
    await navigateTo(`${reqURL.origin}${fullPath}`, { redirectCode: 301, external: true });
}

if (data) {
    newsStore.setNewsAssociationId(data.associationId || '');
}

function stripHtml(html) {
    return (html || '')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/\s+/g, ' ')
        .trim();
}

const pageTitle = computed(() => stripHtml(data?.title || ''));
const pageDescription = computed(() => {
    const describe = stripHtml(data?.describe || '');
    if (describe) return describe;
    const limit = 'en' === locale.value ? 160 : 80;
    return stripHtml(data?.content || '').slice(0, limit);
});

useHead({
    title: pageTitle,
    meta: [{ name: 'description', content: pageDescription }]
});
</script>

<style lang="scss" scoped></style>
